module.exports = __webpack_public_path__ + "static/media/twitter-logo.99ac0bd1.svg";